import React from 'react'
import dragula from 'dragula'

import './dnd.css'

function array_move(curr_arr, old_index, new_index) {
  const arr = [...curr_arr] // avoid mutating state
  if (new_index >= arr.length) {
    let k = new_index - arr.length + 1
    while (k--) {
      arr.push(undefined)
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
  return arr // for testing
}

export class DnD extends React.Component {
  constructor(props) {
    super(props)
    this.id = this.props.id || 'reordenable-list'
    this.getChild = this.getChild.bind(this)
    this.onChange = this.onChange.bind(this)
    this.dragulaOnDrop = this.dragulaOnDrop.bind(this)
  }

  render() {
    const className = this.props.className || ''

    return (
      <div id={this.id} className={className}>
        {this.props.list.map((el, i, _) => (
          <div
            key={typeof el === 'string' ? el : el.key || el.id}
            data-index={i}
          >
            {this.props.getChild(el, i)}
          </div>
        ))}
      </div>
    )
  }

  getChild(el, i) {
    return this.props.getChild(el, i)
  }

  onChange(list) {
    return this.props.onChange(list)
  }

  componentDidMount() {
    dragula([document.getElementById(this.id)], {
      ...(this.props.events || {}),
      accepts: (el, target, source, sibling) => {
        // drop to existent item
        return sibling?.dataset?.index !== undefined && target.contains(el)
      },
    }).on('drop', this.dragulaOnDrop())
  }

  dragulaOnDrop() {
    let component = this
    return (el, target, source, sibling) => {
      let currIndex = parseInt(el.dataset.index)
      let dest = parseInt(sibling?.dataset?.index)

      if (dest > currIndex) {
        dest = dest - 1
      }
      const l = component.props.list
      component.onChange(array_move(l, currIndex, dest))
    }
  }
}
